"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@nexys/utils");
const addressToString = (a) => [a.street, a.postalcode, a.city, a.county, a.state, a.country]
    .map(x => x ? x : '')
    .join(',');
const getAddressString = (address) => {
    if (typeof address === 'string') {
        return address;
    }
    return addressToString(address);
};
exports.latLonFromAddress = (address) => __awaiter(void 0, void 0, void 0, function* () {
    const addressString = getAddressString(address);
    const uAddress = encodeURI(addressString);
    const url = `https://nominatim.openstreetmap.org/search.php?q=${uAddress}&format=json`;
    const r = yield fetch(url).then(x => x.json());
    if (r === []) {
        throw Error('No address could be found');
    }
    return r;
});
exports.mapFromLatLon = (lat, lon, zoomLevel, apiKey, lang = 'en') => {
    const q = lat + ',' + lon;
    const cs = {
        q,
        hl: lang,
        z: zoomLevel,
        output: 'embed',
        key: apiKey
    };
    return 'https://maps.google.com/maps?' + utils_1.url.paramsToString(cs);
};
